import React from 'react';
import additional from './safety_grey.svg'

const Safety_grey = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Safety_grey;
